import { render, staticRenderFns } from "./PositionOverview.vue?vue&type=template&id=af2ae2d0&"
import script from "./PositionOverview.vue?vue&type=script&lang=js&"
export * from "./PositionOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports